// Library Methods
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

// Components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import OperatingManualNavModal from "./OperatingManualNavModal/OperatingManualNavModal";
import OperatingManualNavButtons from "../OperatingManualNavButtons/OperatingManualNavButtons";
import { ChevronLeftIcon, ChevronRightIcon } from "src/assets/icons";

// Constants
import { FIRST_MANUAL_ROUTE, LAST_MANUAL_ROUTE } from "src/constants/enums";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type OperatingManualMobileNavType = {
  navbarOptions: Array<{
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }>;
  handleSelectNavbarOption: (option: {
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }) => void;
  handleSelectSubRoute: (
    option: {
      route: string;
      label: string;
    },
    subOption: {
      route: string;
      label: string;
    }
  ) => void;
  handleMobileNavigation: (indexOffset: number) => void;
};

const OperatingManualMobileNav = ({
  navbarOptions,
  handleSelectNavbarOption,
  handleSelectSubRoute,
  handleMobileNavigation,
}: OperatingManualMobileNavType) => {
  const { t } = useTranslation("operating-manual");
  const location = useLocation();
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);

  const [openNavModal, setOpenNavModal] = useState(false);

  return (
    <Box
      sx={{
        display: { xs: "flex", md: "none" },
        justifyContent: "space-between",
        gap: "20px",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-start", width: "33%" }}>
        <Button
          startIcon={<ChevronLeftIcon />}
          onClick={() => handleMobileNavigation(-1)}
          sx={{
            visibility: location.pathname.includes(FIRST_MANUAL_ROUTE)
              ? "hidden"
              : "visible",
            color: onSurface,
            textTransform: "none",
            textDecoration: "underline",
            backgroundColor: "transparent",
          }}
        >
          {t("Previous")}
        </Button>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", width: "33%" }}>
        <Button
          onClick={() => setOpenNavModal(true)}
          sx={{
            color: onSurface,
            textTransform: "none",
            textDecoration: "underline",
            backgroundColor: "transparent",
          }}
        >
          {t("Index")}
        </Button>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "33%" }}>
        <Button
          endIcon={<ChevronRightIcon />}
          onClick={() => handleMobileNavigation(1)}
          sx={{
            visibility: location.pathname.includes(LAST_MANUAL_ROUTE)
              ? "hidden"
              : "visible",
            color: onSurface,
            textTransform: "none",
            textDecoration: "underline",
            backgroundColor: "transparent",
          }}
        >
          {t("Next")}
        </Button>
      </Box>

      <OperatingManualNavModal
        isOpen={openNavModal}
        onClose={() => setOpenNavModal(false)}
      >
        <Box sx={{ padding: "24px" }}>
          <OperatingManualNavButtons
            navbarOptions={navbarOptions}
            handleSelectNavbarOption={handleSelectNavbarOption}
            handleSelectSubRoute={handleSelectSubRoute}
            onSelectCallback={() => setOpenNavModal(false)}
          />
        </Box>
      </OperatingManualNavModal>
    </Box>
  );
};

export default OperatingManualMobileNav;
